/* ============================================================
   Lucy Mae & Co. — Wishlist
   Storage strategy:
   - Guests: persisted to localStorage.
   - Logged-in customers: mirrored to a customer metafield via an
     App Proxy endpoint (/apps/wishlist) so the list syncs across
     devices. The proxy call is best-effort; localStorage remains the
     source of truth for instant UI. Wire the proxy to a wishlist app
     or a theme app extension in production.
   ============================================================ */
(function () {
  'use strict';

  var STORAGE_KEY = 'lm_wishlist';
  var PROXY_URL = '/apps/wishlist'; // configure via App Proxy if available

  var Wishlist = {
    read: function () {
      try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
      } catch (e) {
        return [];
      }
    },

    write: function (list) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
      } catch (e) {}
      this.syncToCustomer(list);
      document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { list: list } }));
    },

    has: function (id) {
      id = String(id);
      return this.read().some(function (item) { return String(item.id) === id; });
    },

    toggle: function (product) {
      var list = this.read();
      var id = String(product.id);
      var idx = list.findIndex(function (item) { return String(item.id) === id; });
      var added;
      if (idx > -1) {
        list.splice(idx, 1);
        added = false;
      } else {
        list.push(product);
        added = true;
      }
      this.write(list);
      return added;
    },

    remove: function (id) {
      id = String(id);
      var list = this.read().filter(function (item) { return String(item.id) !== id; });
      this.write(list);
    },

    // Best-effort sync for logged-in customers (App Proxy backed).
    syncToCustomer: function (list) {
      if (!window.lmTheme || !window.lmTheme.customerLoggedIn) return;
      try {
        fetch(PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: list })
        }).catch(function () {});
      } catch (e) {}
    },

    // Pull the server copy (if any) and merge into local on load.
    hydrateFromCustomer: function () {
      if (!window.lmTheme || !window.lmTheme.customerLoggedIn) return;
      var self = this;
      fetch(PROXY_URL, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (!data || !Array.isArray(data.items)) return;
          var local = self.read();
          var byId = {};
          local.concat(data.items).forEach(function (item) { byId[String(item.id)] = item; });
          var merged = Object.keys(byId).map(function (k) { return byId[k]; });
          self.write(merged);
          self.refreshButtons();
        })
        .catch(function () {});
    },

    refreshButtons: function () {
      var self = this;
      document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
        var id = btn.getAttribute('data-product-id');
        var heart = btn.querySelector('[data-heart]');
        if (heart) heart.setAttribute('fill', self.has(id) ? '#5C4332' : 'none');
      });
    },

    init: function () {
      var self = this;

      document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-wishlist-toggle]');
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        var product = {
          id: btn.getAttribute('data-product-id'),
          handle: btn.getAttribute('data-product-handle'),
          title: btn.getAttribute('data-product-title'),
          url: btn.getAttribute('data-product-url'),
          price: btn.getAttribute('data-product-price'),
          image: btn.getAttribute('data-product-image')
        };
        var added = self.toggle(product);
        var heart = btn.querySelector('[data-heart]');
        if (heart) heart.setAttribute('fill', added ? '#5C4332' : 'none');
        if (window.LMToast) window.LMToast(added ? 'Added to wishlist' : 'Removed from wishlist');
      });

      self.refreshButtons();
      self.hydrateFromCustomer();
      document.addEventListener('wishlist:updated', function () { self.refreshButtons(); });
    }
  };

  window.LMWishlist = Wishlist;
  if (document.readyState !== 'loading') Wishlist.init();
  else document.addEventListener('DOMContentLoaded', function () { Wishlist.init(); });
})();
